export const formFields = {
  INCLUDE_ALTERNATIVES: 'includeAlternatives',
  ASSIGNED_USER_ID: 'assignedUserId',
  OTP: 'OTP',
  ESTABLISHMENT_COMMENT: 'establishmentComment',
  GRADE_ID: 'gradeId',
  IS_EVALUATED: 'isEvaluated',
  ALL_CRITERIAS_ANSWERED: 'allCriteriasAnswered',
  GRADE: 'grade',
  REF_NOTIFICATION_ID: 'refNotificationId',
  ID: 'id',
  SHID: 'shId',
  SEARCH: 'Search...',
  USERNAME: 'username',
  PASSWORD: 'password',
  REPEAT_PASSWORD: 'confirmPassword',
  EMAIL: 'email',
  OLD_EMAIL: 'oldEmail',
  NEW_EMAIL: 'newEmail',
  REPEAT_EMAIL: 'repeatEmail',
  ESTABLISHMENT: 'establishment',
  SOURCE_COMPANY_ID: 'sourceCompanyId',
  ESTABLISHMENT_AR: 'establishmentAr',
  ESTABLISHMENT_EN: 'establishmentEn',
  ESTABLISHMENT_TYPE: 'establishmentType',
  ESTABLISHMENT_NAME: 'establishmentName',
  ESTABLISHMENT_PHONE: 'esPhone',
  ESTABLISHMENT_EMAIL: 'esEmail',
  ESTABLISHMENT_CITY: 'esCity',
  ESTABLISHMENT_ADDRESS: 'esAddress',
  ESTABLISHMENT_ADDRESS_AR: 'esAddressAr',
  STAKEHOLDER_EMAIL: 'stakeholderEmail',
  STAKEHOLDER_PHONE: 'stakeholderPhone',
  STAKEHOLDER_ADDRESS_EN: 'stakeholderAddressEn',
  ADDRESS_EN: 'addressEn',
  ADDRESS: 'address',
  ADDRESS_AR: 'addressAr',
  STAKEHOLDER_ADDRESS_AR: 'stakeholderAddressAr',
  STAKEHOLDER_RESPONSIBLE_PERSON_F_NAME: 'stakeholderResponsiblePersonFirstName',
  STAKEHOLDER_RESPONSIBLE_PERSON_S_NAME: 'stakeholderResponsiblePersonSurName',
  STAKEHOLDER_RESPONSIBLE_PERSON_PHONE: 'stakeholderResponsiblePersonPhone',
  NAME: 'name',
  NAME_AR: 'nameAr',
  ESTABLISHMENT_ID: 'establishmentId',
  ESTABLISHMENT_STATUS: 'establishmentStatus',
  COMPANY_NAME: 'companyName',
  RETURNED_FROM_REVISION: 'cbRevision',
  NEW_OR_EDIT_SH: 'newOrEditStakeholder',
  PHONE: 'phone',
  MOBILE: 'mobile',
  FAX: 'fax',
  BEGIN_DATE: 'beginDate',
  REGION: 'region',
  CITY: 'city',
  DEMAND_CITY: 'demandCity',
  DISTRICT: 'district',
  CONTACT_PERSON_F_NAME: 'contactPersonFName',
  CONTACT_PERSON_S_NAME: 'contactPersonSName',
  CONTACT_PERSON_NAME: 'contactPersonName',
  CONTACT_PERSON_MOBILE: 'contactPersonMobile',
  AUTH_FILE: 'authFile',
  AUTH_FILE_ID: 'authFileId',
  REVISION_FILE: 'revisionFile',
  REVISION_FILE_ID: 'revisionFileId',
  GLN: 'gln',
  STAKEHOLDER_TYPE: 'stakeholderType',
  STAKEHOLDER_TYPE_ID: 'stakeholderTypeId',
  STAKEHOLDER_NAME: 'stakeholderName',
  STAKEHOLDER_NAME_AR: 'stakeholderNameAr',
  STAKEHOLDER_NAME_EN: 'stakeholderNameEN',
  LICENSE_NUMBER: 'licenseNumber',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
  REGISTRATION_TERMS: 'registrationTerms',
  DRUG_NAME: 'drugName',
  DRUG_Expiry_Date: 'drugExpiryDate',
  REGISTRATION_NUMBER: 'registrationNumber',
  REGISTRATION_NO: 'registrationNo',
  GTIN: 'gtin',
  DRUG_GTIN: 'drugGtin',
  STATUS: 'status',
  STAKEHOLDER: 'stakeholder',
  GENERIC_NAME: 'genericName',
  GENERIC_NAME_ITEM: 'genericNameItem',
  GENERIC_NAME_LIST: 'genericNameList',
  REGISTERED: 'registered',
  REVIEWED: 'reviewed',
  TRADE_NAME_AR: 'nameAr',
  GENERIC_NAME_AR: 'genericNameAr',
  IS_ONLY_HOSPITAL: 'isOnlyHospital',
  LEGAL_STATUS: 'legalStatus',
  PRODUCT_CONTROL: 'productControl',
  AUTHORIZATION_STATUS: 'authorizationStatus',
  MARKETING_STATUS: 'marketingStatus',
  PRICE: 'price',
  ERROR_CODE: 'errorCode',
  ATC_CODE_1: 'atcCode1',
  ATC_CODE_2: 'atcCode2',
  MANUFACTURER_NAME: 'manufacturerName',
  MARKETING_COMPANY: 'marketingCompany',
  MARKETING_COMPANY_COUNTRY: 'marketingCompanyCountry',
  MANUFACTURER_COUNTRY: 'manufacturerCountry',
  PACKAGE_SIZE: 'packageSize',
  PACKAGE_TYPE: 'packageType',
  ROUTE_OF_ADMINISTRATION: 'routeOfAdministration',
  SHELF_LIFE: 'shelfLife',
  STORAGE_CONDITION: 'storageCondition',
  STRENGHT_VALUE: 'strengthValue',
  STRENGHT_VALUE_UNIT: 'strengthValueUnit',
  VOLUME: 'volume',
  UNIT_OF_VOLUME: 'unitOfVolume',
  MINIMUM_STOCK_LEVEL: 'supplierStockthreshold',
  ESSENTIALITY_LEVEL: 'essentialityLevel',
  DOSAGE_FORM: 'dosageForm',
  BLOCK_LEVEL: 'blockLevel',
  BLOCK_REASON: 'blockReason',
  DOMAIN_ID: 'domainId',
  PRODUCT_LEVEL: 'productLevel',
  UNIT_LEVEL: 'unitLevel',
  RECALL_LEVEL: 'recallLevel',
  REASON: 'reason',
  RECALL_REASON: 'recallReason',
  PRODUCT_LIST: 'productList',
  MANUFACTURER_DATE: 'mandate',
  SN: 'sn',
  BN: 'bn',
  NEW_BN: 'newBn',
  LIMIT_QUANTITY: 'limitQuantity',
  GTIN_OR_DRUG_NAME: 'gtinOrDrugName',
  GLN_OR_DRUG_NAME: 'glnOrDrugName',
  MANAGEMENT_USERNAME: 'userName',
  FIRST_NAME: 'firstName',
  SUR_NAME: 'surName',
  LAST_NAME: 'lastName',
  INSERT_DATE: 'insertDate',
  STAKEHOLDER_LIST: 'shList',
  END_DATE: 'endDate',
  START_DATE: 'startDate',
  DRUG_ID: 'drugId',
  DESTINATION_GLN: 'destinationGln',
  SOURCE_STAKEHOLDER: 'sourceGln',
  SOURCE_GLN: 'sourceGln',
  STAKEHOLDER_USERNAME: 'stakeholderUsername',
  STAKEHOLDER_EDIT_USERNAME: 'userName',
  OPERATION_TYPE: 'operationType',
  REF_OPERATION_TYPE: 'refOperationType',
  OPERATION_ID: 'operationId',
  DESTINATION_STAKEHOLDER: 'destinationGln',
  DESTINATION_NAME: 'destinationName',
  NOTIFICATION_DATE: 'notificationDate',
  SUCCESSFULL_PRODUCTION_COUNT: 'successfullProductionCount',
  SUB_USERS: 'inSubUsers',
  CB_SUBUSER: 'cbSubUser',
  NOTIFICATION_ID: 'notificationId',
  SUCCESSFUL: 'successful',
  UNSUCCESSFUL: 'unsuccessful',
  PRIVILEGE_LIST: 'privilegeList',
  DOMAINS: 'domains',
  SERVICE_PRIVILEGE: 'operationList',
  PORTAL_PRIVILEGE: 'privilegeList',
  SCOPE_LIST: 'scopeList',
  RESPONSIBLE_PERSON_F_NAME: 'responsiblePersonFirstName',
  RESPONSIBLE_PERSON_NAME: 'responsiblePersonName',
  RESPONSIBLE_PERSON_S_NAME: 'responsiblePersonSurName',
  RESPONSIBLE_PERSON_PHONE: 'responsiblePersonPhone',
  PRODUCT_CONTROLLED_STATUS: 'productControlledStatus',
  EMAIL_STATUS: 'emailStatus',
  SENDER_MAIL_ADDRESS: 'senderMailAddress',
  DISPLAY_NAME: 'dispalyName',
  HOST: 'host',
  PORT: 'port',
  SSL: 'ssl',
  COMMENT: 'comment',
  DELIVERY_DATE: 'deliveryDate',
  EXPIRATION_DATE: 'expirationDate',
  TYPE: 'type',
  OPERATION: 'operation',
  EXPIRY_DATE: 'expireDate',
  READ: 'read',
  ANSWERED: 'answered',
  REQUEST_ID: 'requestId',
  SOURCE_ESTABLISHMENT: 'sourceEstablishment',
  DESTINATION_ESTABLISHMENT: 'destinationEstablishment',
  TYPE_ID: 'typeId',
  TYPE_ID_S: 'typeIdS',
  CREATE_DATE: 'createDate',
  DESCRIPTION: 'description',
  LANGUAGE: 'language',
  LANGUAGE_S: 'languageS',
  TITLE: 'title',
  TITLE_S: 'titleS',
  ANNOUNCEMENT_ID: 'announcementId',
  ANNOUNCEMENT_STAKEHOLDER_TYPE: 'announcementStakeholderType',
  NAME_SURNAME: 'nameSurname',
  PURCHASED_FROM: 'purchasedFrom',
  DATE_TIME: 'dateTime',
  COUNTRY: 'country',
  IS_DELETED: 'isDeleted',
  EXPLANATION: 'explanation',
  PRODUCT_NAME: 'productName',
  INVESTIGATION_RESULT: 'result',
  NOTE: 'notes',
  CLOSED: 'closed',
  CAUSE: 'cause',
  CONTENT: 'content',
  CONTENT_S: 'contentS',
  CURRENT_STATUS: 'currentStatus',
  CURRENT_MARKETING_STATUS: 'currentMarketingStatus',
  IS_IMPORTTABLE: 'isImportable',
  IS_EXPORTABLE: 'isExportable',
  ENTERED: 'entered',
  FEEDBACK_SENT: 'feedbackSent',
  REFERENCE_NUMBER: 'referenceNumber',
  UNDEFINED_SERVICE_TYPE: 'undefinedServiceType',
  STAKEHOLDER_GLN: 'stakeholderGln',
  TO_STAKEHOLDER: 'toStakeholder',
  OFFER_TYPE: 'offerType',
  ALTERNATIVE: 'alternative',
  ALTERNATIVE_DRUG_ID: 'alternativeDrugId',
  ALTERNATIF: 'alternatif',
  PARTIAL: 'partial',
  DEMAND_TYPE: 'demandType',
  SN_LIST: 'snRequestList',
  CONTACT_COMMENT: 'contactComment',
  QUANTITY: 'amount',
  CONTACTED_BEFORE: 'contacted',
  SHORTAGE_TYPE: 'shortageType',
  SHORTAGE_REASON: 'shortageReason',
  AVAILABLE_QUANTITY: 'availableQuantity',
  DISTRIBUTED_QUANTITY: 'distributedQuantity',
  BENEFICIARY_PARTIES: 'beneficiaryParties',
  SHIPMENT_QUANTITY: 'shipmentQuantity',
  EXPECTED_DATE: 'expectedDate',
  MARKET_DEMAND: 'marketDemand',
  SHORTAGE_TYPE_OTHER: 'shortageTypeOther',
  SHORTAGE_REASON_OTHER: 'shortageReasonOther',
  SHORTAGE_TYPE_ID: 'shortageTypeId',
  SHORTAGE_REASON_ID: 'shortageReasonId',
  CURRENT_AVAILABILITY_STATUS: 'currentAvailabilityStatus',
  APPROVAL_STATUS: 'approvalStatus',
  APPROVAL_DES: 'approvalStatusDesc',
  APPROVAL_DATE: 'approvalDate',
  TRADE_NAME: 'name',
  SOURCE_COMMENT: 'sourceComment',
  FILE: 'file',
  REGESTER_NUMBER: 'registerNumber',
  DATA_MATRIX: 'dataMatrix',
  PRESCRIPTION_ID: 'prescriptionId',
  PRESCRIPTION_DATE: 'prescriptionDate',
  DOCTOR_ID: 'doctorId',
  PATIENT_ID: 'patientId',
  DEACTIVATION_REASEON: 'deactivstionReason',
  AVAILABILITY_STATUS: 'availabilityStatus',
  REMARK: 'remark',
  FILES: 'files',
  REQUESTED_STATUS: 'requestedStatus',
  REQUESTED_STATUS_DESC: 'requestedStatusDesc',
  REQUEST_DATE: 'requestDate',
  OLD_PASSWORD: 'oldPassword',
  NEW_PASSWORD: 'passwordHash',
  NOTIFICATION_ITEMS: 'notificationItems',
  IS_HANDELED: 'isHandeled',
  RESPONSE_CODE: 'responseCode',
  Operation_Type: 'Operation Type',
  SH_NAME: 'shName',
  REQUIRED_ACTION_ID: 'requiredActionId',
  REQUIRED_ACTION_OTHER: 'requiredActionOther',
  REASON_ID: 'reasonId',
  REASON_OTHER: 'reasonOther',
  CURRENT_QUANTITY: 'currentQuantity',
  NEEDED_QUANTITY: 'neededQuantity',
  USED_QUANTITY: 'usedQuantity',
  SFDA_REPLY: 'sfdaReply',
  ESCALATION_REASON: 'EscalationReason',
  ESCALATION_REASON_COMMENT: 'EscalationReasonComment',
  OFFER_ID: 'id',
  ACCEPTED_QUANTITY: 'acceptedQuantity',
  STATUS_DESC: 'statusDesc',
  VIEW_HISTORICAL_DATA: 'viewHistoricalData',
  DEMAND_ID: 'demandId',
  OFFER_ID_SEARCH: 'offerId',
  CURRENT_EXPIRY_DATE: 'currentExpiryDate',
  SUBSCRIPTION_PACKAGE: 'subscriptionPackage',
  CONSUMPTION_RATE: 'consumptionRate',
  TRANSACTION_ID: 'transactionID',
  CITY_ID: 'cityId',
  REGION_ID: 'regionId',
  COMPANY_ID: 'companyId',
  TRANSACTION_Id: 'transactionId',
  IMPORT_REQUEST_NUMBER: 'importRequestNumber',
  IMPORTED_QUANTITY: 'importedQuantity',
  COUNTRY_OF_MANUFACTURER: 'countryOfManufacturer',
  FASEH_CERTIFICATE: 'fasehCertificate',
  AUTHORIZED_GTIN_CERTIFICATE: 'authorizedGtinCertificate',
  BENEFICIARY_ESTABLISHMENT_LETTER: 'beneficiaryEstablishmentLetter',
  IMPORTER_ESTABLISHMENT_LETTER: 'importerEstablishmentLetter',
  UNREGISTERED_DRUGS_REQUEST_TYPE: 'requestType',
  ESTABLISHMENT_LIST: 'companyList',
  DRUG_INFO: 'drugInfo',
  STRENGTH_VALUE: 'strengthValue',
  STRENGTH_VALUE_UNIT: 'strengthValueUnit',
  JUSTIFICATION_COMMENT: 'JustificationComment',
  DRUG_EXPIRY_DATE: 'drugExpiryDate',
  LABEL_NAME: 'labelName',
  LABEL_LEVEL: 'labelLevel',
  GTIN_OR_DRUG_NAME_LIST: 'gtinOrDrugNameList',
  MANUAL_INSERTED_DATA: 'manualInsertedData',
  REGISTRATION_NUMBER_LIST: 'registrationNumberList',
  TO_GLN: 'toGln',
  STOCK_MATCH_QUANTITY: 'quantity',
  MATCH_PERCENTAGE_FROM: 'matchPercentageFrom',
  MATCH_PERCENTAGE_TO: 'matchPercentageTo',
  MATCH_PERCENTAGE: 'matchPercentage',
  QUANTITY_DIFFERENCE_FROM: 'quantityDifferenceFrom',
  QUANTITY_DIFFERENCE_TO: 'quantityDifferenceTo',
  STOCK_MATCH_ID: 'stockMatchId',
  STOCK_MATCH_DATE: 'stockMatchDate',
  HISTORY_ID: 'historyId',
  STOCK_MATCH_DETAILS_ID: 'stockMatchDetailsId',
  ACTIVE_QUANTITY: 'activeQuantity',
  ACTUAL_QUANTITY: 'actualQuantity',
  STOCK_DIFFERENCE: 'stockDifference',
  SUBSCRIPTION_TYPE: 'subscriptionType',
  EXPIRY_PRIORITY: 'expiryPriority'
};
export const evaluations = {

};
